import { render, staticRenderFns } from "./train.vue?vue&type=template&id=79669d12&"
import script from "./train.vue?vue&type=script&lang=ts&"
export * from "./train.vue?vue&type=script&lang=ts&"
import style0 from "./train.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports